import type {PullRequestReviewItem, PullRequestReviewState} from '../../../../page-data/payloads/timeline'

const actionText: Partial<Record<PullRequestReviewState, string>> = {
  pending: 'pending',
  commented: 'commented on these changes',
  changes_requested: 'requested changes',
  approved: 'approved these changes',
  dismissed: 'had their review dismissed',
}

export function PullRequestReviewText({item}: {item: PullRequestReviewItem}) {
  const text = actionText[item.additionalInfo.state] ?? 'reviewed'
  return <>{text}</>
}
